import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component RecurringSmallIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <RecurringSmallIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <RecurringSmallIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const RecurringSmallIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    svgRef?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="RecurringSmallIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.182 2.818l.113.117.107.119a4.43 4.43 0 011.02 2.107l.021.125c.036.22.054.444.057.666h-.004l.001.048H9.493a3.475 3.475 0 00-.715-2.13l-.047-.06a3.5 3.5 0 00-5.119-.369l-.087.084.707.707-2.436.315.315-2.436.707.707A4.488 4.488 0 016.18 1.504c1.05.041 2.088.449 2.907 1.222l.095.092zM2.818 9.182a4.446 4.446 0 01-1.249-2.394 4.508 4.508 0 01-.069-.783h.003V6h1.004a3.472 3.472 0 00.913 2.365l.105.11a3.5 3.5 0 004.863.084l.087-.084-.707-.707 2.436-.315-.315 2.436-.707-.707a4.5 4.5 0 01-6.364 0z"
      />
    </svg>
  )
);
RecurringSmallIcon.displayName = "RecurringSmallIcon";
export default RecurringSmallIcon;
